import type { PatientEntryMode } from "./patientEntryMode/useSavePatientEntryMode";

export type StateTypes = {
  breakpoint: unknown;
  fastrHomeLink: string;
  patientEntryMode: PatientEntryMode;
  theme: string;
};

export const saveState = <StateKey extends keyof StateTypes>(
  key: StateKey,
  state: StateTypes[StateKey]
): void => {
  try {
    const serialState = JSON.stringify(state);
    sessionStorage.setItem(`appState.${key}`, serialState);
  } catch (err) {
    console.log(err);
  }
};
